import { useCallback, useEffect, useRef } from "react";
import UpArrowIcon from "assets/arrow-up.svg?react";
import DownArrowIcon from "assets/arrow-down.svg?react";

import styles from "./index.module.css";
import { IconButton } from "components/icon-button";

export const CallSkip = ({
  onSelectOption,
  currentNodeId,
}: {
  onSelectOption: (id: string | number | null, proceed: boolean) => void;
  currentNodeId: number | null;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.code === "ArrowDown") {
        event.preventDefault();
        onSelectOption(currentNodeId, true);
      } else if (event.code === "ArrowUp") {
        event.preventDefault();
        onSelectOption(currentNodeId, false);
      }
    },
    [currentNodeId, onSelectOption],
  );

  useEffect(() => {
    const targetWindow = containerRef.current?.ownerDocument.defaultView ?? window;
    targetWindow.addEventListener("keydown", handleKeyDown);
    return () => targetWindow.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div ref={containerRef} className={styles.container}>
      <IconButton aria-label="Previous" onClick={() => onSelectOption(currentNodeId, false)}>
        <UpArrowIcon width={24} height={24} />
      </IconButton>

      <IconButton aria-label="Next" onClick={() => onSelectOption(currentNodeId, true)}>
        <DownArrowIcon width={24} height={24} />
      </IconButton>
    </div>
  );
};
